<script lang="ts" setup>
import { computed } from 'vue'

import { SectionHeading, BlockContainer, SectionHeadingShapeInt } from '@toni/brand-ui'

import { usePageStore } from '../../../../../stores/page'
import { usePageBlockWidth } from '../../../../../composables/use-page-block-width.ts'
import { useContentBlock } from '../../../../../content-blocks/composables/use-content-block'

const props = defineProps<{ id: string }>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'interline')

const pageStore = usePageStore()
const isHome = computed(() => pageStore.isHome as boolean)
const brand = computed(() => pageStore.brandFromStore as string)
const size = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brand.value).value)

const isStructure = computed(() => pageStore.pageData.pageMeta.structureTermType === 'structure')
</script>

<template>
  <BlockContainer v-if="isStructure"
                  :size="size"
                  class="mt-8 mb-6 md:mt-12 md:mb-8 flex flex-row space-x-2 sm:space-x-2.5 md:space-x-3 lg:space-x-3.5">
    <div class="flex flex-row items-center space-x-2 sm:space-x-2.5 md:space-x-3 lg:space-x-3.5">
      <SectionHeadingShapeInt variant="tertiary" />
      <SectionHeading :uppercase="false"
                      variant="tertiary">
        <component
          :is="contentBlock.data.interline.heading || 'h2'">
          {{ contentBlock.data.interline.text }}
        </component>
      </SectionHeading>
    </div>
  </BlockContainer>
</template>
